"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KindsEnum = exports.Kinds = void 0;
var Kinds = {
  EntirePlace: 0,
  PrivateRoom: 1,
  SharedRoom: 2
};
exports.Kinds = Kinds;
var KindsEnum = {
  EntirePlace: 'ENTIRE_PLACE',
  PrivateRoom: 'ROOM',
  SharedRoom: 'SHARED'
};
exports.KindsEnum = KindsEnum;